import { COLORS } from '@/app/constants';
import { VITE_APP_API_MEDIA_URL } from '@/app/constants/APIKEYS';
import { Modal } from 'antd';
import styled from 'styled-components';

export const CustomModal = styled(Modal)<{ systemImage: string }>`
  .ant-modal-content {
    height: 650px;
    width: 480px;
    border-radius: 6px;
    box-shadow: none;
    background-color: #1f1f1f;
    background-image: ${({ systemImage }) =>
      systemImage ? `url(${VITE_APP_API_MEDIA_URL}/${systemImage})` : 'none'};
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    padding: 0;
    font-family: 'NanumSquareRound', 'Pretendard', sans-serif !important;
  }

  .ant-modal-body {
    height: 100%;
  }
`;

export const ModalContainer = styled.div<{ $isMobile: boolean }>`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  padding: 40px;
  gap: ${({ $isMobile }) => ($isMobile ? '20px' : '0')};
  overflow: hidden;
`;

export const ContentWrapper = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
`;

export const LogoSection = styled.div`
  margin-bottom: 40px;
`;

export const PairInfoSection = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  margin-bottom: 20px;
`;

export const PairName = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${({ theme }) => theme.COLORS.textw};
  font-family: 'NanumSquareRound', sans-serif;
  letter-spacing: -0.54px;
`;

export const LongShortBadge = styled.span<{ isLong: boolean }>`
  font-size: 14px;
  font-weight: 700;
  color: ${({ isLong }) => (isLong ? COLORS.lightGreen : COLORS.lightRed)};
  background-color: ${({ isLong }) =>
    isLong ? 'rgba(7, 217, 98, 0.1)' : 'rgba(246, 71, 93, 0.1)'};
  border-radius: 4px;
  padding: 0 4px;
  font-family: 'NanumSquareRound', sans-serif;
  letter-spacing: -0.42px;
  line-height: 20px;
`;

export const PnlSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 46px;
`;

export const RoiDisplay = styled.div<{ isPositive: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PlusIcon = styled.div<{ isPositive: boolean }>`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ isPositive }) =>
    isPositive ? COLORS.lightGreen : COLORS.lightRed};
  font-size: 24px;
  font-weight: 700;
`;

export const RoiValue = styled.span<{ isPositive: boolean }>`
  font-size: 42px;
  font-weight: 700;
  color: ${({ isPositive }) =>
    isPositive ? COLORS.lightGreen : COLORS.lightRed};
  font-family: 'NanumSquareRound', sans-serif;
  letter-spacing: -1.26px;
  line-height: 1;
`;

export const PnlValue = styled.span<{ isPositive: boolean }>`
  font-size: 24px;
  font-weight: 400;
  color: ${({ isPositive }) =>
    isPositive ? COLORS.lightGreen : COLORS.lightRed};
  font-family: 'NanumSquareRound', sans-serif;
  letter-spacing: -0.72px;
`;

export const InfoAndQrSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const PriceInfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const InfoLabel = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #9897a0;
  font-family: 'NanumSquareRound', sans-serif;
  letter-spacing: -0.42px;
  margin: 0;
`;

export const InfoValue = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  font-family: 'NanumSquareRound', sans-serif;
  letter-spacing: -0.42px;
  margin: 0;
`;

export const QrSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  position: relative;
  right: 16px;
  align-self: flex-end;
`;

export const CharacterImage = styled.div`
  width: 124px;
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  top: calc(14px - 50%);
  left: 50%;
  transform: translateX(-50%);
`;

export const QRContainer = styled.div`
  width: 92px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.white};
  border-radius: 6px;
  padding: 20px 6px 6px 6px;
`;

export const ReferralInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

export const ReferralLabel = styled.p`
  font-size: 12px;
  font-weight: 400;
  color: #9e9e9e;
  font-family: 'NanumSquareRound', sans-serif;
  letter-spacing: -0.36px;
  margin: 0;
`;

export const ReferralCode = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.COLORS.textw};
  font-family: 'NanumSquareRound', sans-serif;
  margin: 0;
`;

export const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
  z-index: 2;
`;

export const CheckboxSection = styled.div`
  display: flex;
  gap: 18px;
  align-items: center;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;

export const CustomCheckbox = styled.div<{ checked: boolean }>`
  width: 14px;
  height: 14px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ checked }) => (checked ? '#07D993' : 'transparent')};
  border: ${({ checked }) => (checked ? 'none' : '1.4px solid #777986')};

  svg {
    width: 10px;
    height: 10px;
    color: #0d1117;
  }
`;

export const CheckboxText = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.COLORS.textw};
  font-family: 'NanumSquareRound', sans-serif;
  letter-spacing: -0.36px;
`;

export const ButtonSection = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
`;

export const CancelBtn = styled.button`
  flex: 1;
  height: 48px;
  border: 1px solid #353535;
  border-radius: 12px;
  background-color: transparent;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  font-family: 'NanumSquareRound', sans-serif;
  letter-spacing: -0.28px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: transparent;
    border: 1px solid #07d993;
  }
`;

export const DownloadBtn = styled.button`
  flex: 1;
  height: 48px;
  background-color: #07d993;
  border: 1px solid transparent;
  border-radius: 12px;
  color: #0d1117;
  font-size: 14px;
  font-weight: 700;
  font-family: 'NanumSquareRound', sans-serif;
  letter-spacing: -0.28px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: transparent;
    border: 1px solid #07d993;
    color: #07d993;
  }
`;

export const ModalDesContainer = styled.div`
  position: relative;
  margin-top: 42px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  z-index: 2;
`;

export const ModalDesName = styled.div<{ isDarkmode: boolean }>`
  font-size: 14px;
  font-weight: 500;
  color: ${({ isDarkmode }) => (isDarkmode ? `#9897A0` : `#757575`)};
`;

export const ModalDesValue = styled.div`
  font-size: 16px;
  display: flex;
  align-items: center;
`;

export const BackSvg = styled.svg`
  width: 424.8px;
  height: 356.08px;
`;
